import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './components/layout/layout.component';
import { QuotationRequestsComponent } from './pages/quotation-requests/quotation-requests.component';
import { ActiveQuotationsComponent } from './pages/active-quotations/active-quotations.component';
import { QuotationHistoryComponent } from './pages/quotation-history/quotation-history.component';
import { QuotationGuard } from '@app/_guards/quoutation.guard';
const routes: Routes = [


    {
        path: '',
        component: LayoutComponent,
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'requests'
            },
            {
                path: 'requests', canActivate: [QuotationGuard],
                component: QuotationRequestsComponent
            },
            {
                path: 'active',
                component: ActiveQuotationsComponent
            },
            {
                path: 'history',
                component: QuotationHistoryComponent
            },
        ]
    },

];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class QuotationRoutingModule { }
